import { render, staticRenderFns } from "./CautionBill.vue?vue&type=template&id=56add58d"
import script from "./CautionBill.vue?vue&type=script&lang=js"
export * from "./CautionBill.vue?vue&type=script&lang=js"
import style0 from "./CautionBill.vue?vue&type=style&index=0&id=56add58d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports